import { AbstractPopUp, AbstractPopUpParams } from './AbstractPopUp';
import { PopUpName } from '../core/managers/PopUpManager';
import { Button } from '../UI/elements/buttons/Button';
import { createButton } from '../utils/GameEngine';
import { ResetButtonRound } from '../UI/elements/buttons/ResetButtonRound';
import { Events } from '../core/Events';
import { GameAnalytics } from '../analytics/GameAnalytics';
import { AnalyticsEventNames } from '../analytics/AnalyticsEventNames';

export interface CheatPopupParams extends AbstractPopUpParams {
    callback: (level: number) => any;
}

export class CheatPopup extends AbstractPopUp {
    constructor(public readonly name: PopUpName, public params: AbstractPopUpParams) {
        super(name, params);
    }

    protected drawLayout(params: any): void {
        super.drawLayout(params);
        this.text.x = this.background.width / 2;
        this.drawButtons();
        this.addResetButton();
    }

    protected drawButtons(): void {
        let count: number = 10;
        for (let i: number = 0; i < 5; i++) {
            for (let j: number = 0; j < 4; j++) {
                const index: number = count;
                const button: Button = createButton(
                    'yellow_button_small@2x',
                    this,
                    (): void => {
                        (this.params as CheatPopupParams).callback(index);
                        this.hide();
                    },
                    '' + index,
                    true,
                    true,
                    0.7);
                // button.position.set(i * 10, 200 % i * 10);
                count += 6;
                button.position.set(120 + i * 130, 160 + j * 50);
                console.log(i + 'X: ' + button.x + ' Y: ' + button.y);
            }
        }
    }

    private addResetButton(): void {
        const resetButton: ResetButtonRound = new ResetButtonRound((): void => {
            dispatchEvent(new CustomEvent(Events.showResetPopup));
            GameAnalytics.getInstance().logDesign(AnalyticsEventNames.reset_progress);
        }, 0.5);
        resetButton.scale.set(0.5, 0.5);
        this.addChild(resetButton);
        resetButton.position.set(115, 60);
    }
}